import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { createContext, useMemo, useState } from 'react';

import { useEnsureContextWithinProvider } from './hooks/useEnsureContextWithinProvider';

interface BundleStatusesContext {
  bundleStatuses: Record<string, string>;
  setBundleStatuses: Dispatch<SetStateAction<Record<string, string>>>;
}

export const BundleStatusesContext =
  createContext<BundleStatusesContext | null>(null);

export const BundleStatusesProvider = ({ children }: PropsWithChildren) => {
  const [bundleStatuses, setBundleStatuses] = useState<Record<string, string>>(
    {} as Record<string, string>
  );

  const context = useMemo(
    () => ({
      bundleStatuses,
      setBundleStatuses,
    }),
    [bundleStatuses, setBundleStatuses]
  );

  return (
    <BundleStatusesContext.Provider value={context}>
      {children}
    </BundleStatusesContext.Provider>
  );
};

export const useBundleStatuses = () =>
  useEnsureContextWithinProvider(BundleStatusesContext, 'BundleStatuses');
